// src/components/PoEntryRow.jsx
import React, {useState, useEffect} from 'react'
import { FaTrashAlt } from 'react-icons/fa';
import { dateInDMY } from '../../Helpers';
import { SERVER_API } from '../../fileWithConstants';
import toast from 'react-hot-toast';
import axios from 'axios'
import { updateThanFormData, deleteThanRow } from "../../utils/thanFormDataUtils";
const PoEntryRow = ({ po, index, handleChange, deleteRow, thanFormData, setThanFormData }) => {

const [warehouse, setWarehouse] = useState([]);
const [thanVisibility, setThanVisibility] = useState({});
const [thanRowVisibility, setThanRowVisibility] = useState({});
const [poParentData, setPoParentData] = useState({});
const toggleThanVisibility = (po_data_id) => {
  setThanVisibility((prev) => ({
    ...prev,
    [po_data_id]: !prev[po_data_id]
  }));
};

useEffect(()=>{
    getWareHouse();
},[])


 const getWareHouse = async()=>{
        try {
            const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-warehouse`);
            if(data?.success && data?.wdata.length>0){
                /* console.log(data) */
                setWarehouse(data?.wdata);
            }else{
              toast.error('Some thing went wrong while getting Warehouse data.')
            }
        } catch (error) {
            console.log(error)
        }
    }


const toggleThanRowVisibility = (podata, po_data_id) => {
  setThanRowVisibility((prev) => {
    const currentlyVisible = !!prev[po_data_id]; // coerce to boolean
    const newVisibility = !currentlyVisible;

    // If hiding, just toggle the flag
   /*  if (!newVisibility) {
      return {
        ...prev,
        [po_data_id]: false
      };
    } */

    // If showing, validate data and setup rows
    const data = thanFormData[po_data_id];
    const totalThan = parseInt(data?.totalThan || 0);
    const warehouse = data?.warehouse || '';
    const totalQty = data?.totalQty || '';

    if (isNaN(totalThan) || totalThan <= 0) {
      alert("Please enter a valid Total Than");
      return prev; // Don't update
    }

    return {
      ...prev,
      [po_data_id]: {
        rows: Array.from({ length: totalThan }),
        warehouse,
        totalQty,
      }
    };
  });
};


//const [thanFormData, setThanFormData] = useState({});

const handleThanFormChange = (po,po_data_id, field, value) => {
  setThanFormData((prev) => ({
    ...prev,
    [po_data_id]: {
      ...prev[po_data_id],
      parent_id:po.id,
      [field]: value,
    },
  }));
};


const handleRowChange = (po,po_data_id, rowIndex, event) => {
  const { name, value } = event.target;

  setThanFormData((prev) => {
    const prevRows = prev[po_data_id]?.row || [];

    const updatedRow = {
      ...prevRows[rowIndex],
      [name]: value,
    };

    updatedRow.po_id = po.po_id; 
    updatedRow.po_data_id = po.po_data_id; 

    const qty = parseFloat(updatedRow.inw_qty) || 0;
    const price = parseFloat(updatedRow.inw_price) || 0;
    const discount = parseFloat(updatedRow.inw_discount) || 0;

    const baseAmount = qty * price;
    const inw_amount = baseAmount - (baseAmount * (discount / 100));
    updatedRow.inw_amount = inw_amount.toFixed(2);

    const updatedRows = [...prevRows];
    updatedRows[rowIndex] = updatedRow;

    return {
      ...prev,
      [po_data_id]: {
        ...prev[po_data_id],
        row: updatedRows,
      },
    };
  });
};




useEffect(() => {
  setPoParentData((prev) => ({
    ...prev,
    ...thanFormData,
  }));
  /* console.log('==poParentData=>>>',poParentData) */
}, [thanFormData]);



   
  return (

    <tbody key={index}>
      <tr onClick={()=>{ toggleThanVisibility(po.po_data_id) }}>
        <td>{index + 1}</td>
        <td className="text-center">PO-{po.po_num}</td>
        <td className="text-start">{po.supplier_name}</td>
        <td className="text-start">{po.fabric}</td>
        <td className="text-start">{po.supplierfbname}</td>
        <td className="text-center">{po.po_qty}</td>
        <td className="text-center">{po.price}</td>
        <td className="text-center">{dateInDMY(po.po_date)}</td>
        <td className="text-center">{dateInDMY(po.del_date)}</td>
        <td>
                  <button
                    className="btn btn-danger"
                    type="button"
                    onClick={() => deleteRow(index,po.po_data_id)}
                  >
                    <FaTrashAlt />
                  </button>
                </td>
      </tr>
    {thanVisibility[po.po_data_id] && (
      <tr>
        <td colSpan="10">
          <div className="than text-center" style={{
              marginBottom: '20px',
              width: '70%',
              margin: 'auto',
              padding: 0
            }}>
              <div className="row justify-content-center">
                <div className='col-md-2'> 
                  {  /* JSON.stringify(thanRowVisibility, null, 4) */ }
                  
                    Total Than: <input
                                type="text"
                                className="form-control"
                                required
                                value={thanFormData[po.po_data_id]?.totalThan || ""}
                                onChange={(e) =>
                                handleThanFormChange(po,po.po_data_id, 'totalThan', e.target.value)
                                }
                            />
                </div>
                
                <div className='col-md-2'>
                    Total QTY: <input
                                    type="text"
                                    className="form-control"
                                    required
                                    value={thanFormData[po.po_data_id]?.totalQty || ""}
                                    onChange={(e) =>
                                    handleThanFormChange(po,po.po_data_id, 'totalQty', e.target.value)
                                    }
                                />
                </div>
                <div className='col-md-2'>
                   
                    

                    <button
                    type="button"
                    className='btn btn-primary'
                    onClick={() => toggleThanRowVisibility(po, po.po_data_id)}
                    style={{ marginTop: '14px', float: 'left' }}
                  >
                    OK
                  </button>

                </div>
              </div>
          
      <table className="table table-responsive table-hover">
          {thanRowVisibility[po.po_data_id]?.rows?.map((_, thanIndex) => (
            
           <>
            {  /* JSON.stringify(thanFormData, null, 4) */ }
            {thanIndex===0?(
                <thead>
                <tr className="align-item">
                    <th>#</th>
                    <th className="text-center">Warehouse</th>
                    <th className="text-center">Quantity</th>
                    <th className="text-center">Unit</th>
                    <th className="text-center">Price</th>
                    <th className="text-center">Dis %</th>
                    <th className="text-center">Amount INR</th>
                </tr>
                </thead>
            ):
            ''
            }
            <tbody key={thanIndex+1}>
              <tr key={thanIndex}>
                <td className="text-center">{thanIndex + 1}</td>
                <td className="text-center">
                  <select className="form-control"  required
                  onChange={(event) => handleRowChange(po,po.po_data_id,thanIndex, event)}  
                  name={`warehouse`}
                  value={thanFormData?.[po.po_data_id]?.row?.[thanIndex]?.warehouse || thanRowVisibility[po.po_data_id].warehouse}>
                     <option value={''}>--Select--</option>
                     {warehouse?.map((house,index)=>(
                        <option value={house.id}>{house.name}</option>
                     ))} 
                  </select>
                </td>
                <td className="text-center">
                  <input
                    type="text"
                    name={`inw_qty`}
                    value={thanFormData?.[po.po_data_id]?.row?.[thanIndex]?.inw_qty || ''}
                    onChange={(event) => handleRowChange(po,po.po_data_id,thanIndex, event)}
                    required
                    className="po-inward-input form-control"
                    placeholder="QTY"
                  />
                </td>
                <td className="text-center">{po.unit}</td>
                <td className="text-center">
                  {po.price}:
                  <input
                    type="text"
                    name={`inw_price`}
                    value={thanFormData?.[po.po_data_id]?.row?.[thanIndex]?.inw_price || ''}
                    onChange={(event) => handleRowChange(po,po.po_data_id,thanIndex, event)}
                    required
                    className="po-inward-input form-control"
                    placeholder="Price"
                  />
                </td>
                <td className="text-center">
                  {po.discount}:
                  <input
                    type="text"
                    name={`inw_discount`}
                    value={thanFormData?.[po.po_data_id]?.row?.[thanIndex]?.inw_discount || 0}
                    onChange={(event) => handleRowChange(po,po.po_data_id,thanIndex, event)}
                    required
                    className="po-inward-input form-control"
                    placeholder="Dis."
                  />
                </td>
                <td className="text-center">
                  {(() => {
                    const rowData = thanFormData?.[po.po_data_id]?.row?.[thanIndex] || {};
                    const qty = parseFloat(rowData.inw_qty) || 0;
                    const price = parseFloat(rowData.inw_price) || 0;
                    const discount = parseFloat(rowData.inw_discount) || 0;

                    const baseAmount = qty * price;
                    const totalAmount = baseAmount - (baseAmount * (discount / 100));

                    return (
                      <input
                        type="text"
                        name="inw_amount"
                        value={totalAmount.toFixed(2)}
                        onChange={(event) => handleRowChange(po,po.po_data_id,thanIndex, event)}
                        required
                        className="po-inward-input form-control"
                        placeholder="Amount"
                      />
                    );
                  })()}
                </td>
              </tr>
              {  (thanRowVisibility[po.po_data_id]['rows'].length===thanIndex+1)?(
                 <>

                 <tr key={thanIndex}>
                    <td colSpan="2" className='text-end'>
                     <strong>Sub-Total:</strong>
                    </td>
                    <td>
                      {
                        (thanFormData[po.po_data_id]?.row || []).reduce(
                          (sum, row) => sum + Number(row.inw_qty || 0),
                          0
                        )
                      }
                    </td>

                    <td>
                   
                    </td>

                     <td>
                      {
                        (thanFormData[po.po_data_id]?.row || []).reduce(
                          (sum, row) => sum + Number(row.inw_price || 0),
                          0
                        )
                      }
                    </td>
                     <td>
                      {
                        (thanFormData[po.po_data_id]?.row || []).reduce(
                          (sum, row) => sum + Number(row.inw_discount || 0),
                          0
                        )
                      }
                    </td>

                     <td>
                      {
                        (thanFormData[po.po_data_id]?.row || []).reduce(
                          (sum, row) => sum + Number(row.inw_amount || 0),
                          0
                        )
                      }
                    </td>

                    </tr> 

                    <tr>
                    <td colSpan="2">
                     
                    </td>
                    <td>
                    Short:  <input
                    type="text"
                    name={`sort`}
                    value={thanFormData[po.po_data_id]?.sort || ""}
                    onChange={(e) =>
                             handleThanFormChange(po,po.po_data_id, 'sort', e.target.value)
                            }
                    required
                    className="po-inward-input form-control"
                    />
                    </td>

                    <td>
                    Excess: 
                    <input
                    type="text"
                    name={`excess`}
                    value={thanFormData[po.po_data_id]?.excess || ""}
                    onChange={(e) =>
                             handleThanFormChange(po,po.po_data_id, 'excess', e.target.value)
                            }
                    required
                    className="po-inward-input form-control"
                    />
                    </td>

                     <td>
                    Price/Unit: 
                    <input
                    type="text"
                    name={`sort_excess_price`}
                    value={thanFormData[po.po_data_id]?.sort_excess_price || ""}
                    onChange={(e) =>
                             handleThanFormChange(po,po.po_data_id, 'sort_excess_price', e.target.value)
                            }
                    required
                    className="po-inward-input form-control"
                    />
                    </td>
                    <td className="text-start"> 
                      <strong>PO Summary</strong><br/>
                      QTY: {po.po_qty}<br/>
                      Amount: {po.amount} 
                    </td>
                    <td className="text-start"> 
                      <strong>PO-In Summary</strong><br/>
                      QTY:  {
                              (thanFormData[po.po_data_id]?.row || []).reduce(
                                (sum, row) => sum + Number(row.inw_qty || 0),
                                0
                              )
                            }<br/> 
                      Amount: {
                                (thanFormData[po.po_data_id]?.row || []).reduce(
                                  (sum, row) => sum + Number(row.inw_amount || 0),
                                  0
                                )
                              }
                    </td>

                    </tr>
                  </>
               
              ):''}
             

            </tbody>
          </>
        ))}
          </table>
          </div>
        </td>
      </tr>
       )}
    </tbody>

  );
};

export default PoEntryRow;
